"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var PlayerFavoriteGamesEditor = /** @class */ (function (_super) {
    __extends(PlayerFavoriteGamesEditor, _super);
    function PlayerFavoriteGamesEditor(props) {
        return _super.call(this, props) || this;
    }
    PlayerFavoriteGamesEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            brand_id: 0,
            brand_title: "",
            gws_gameprovider_id: 0,
            gws_gameprovider_title: "",
            gws_gameprovider_game_id: 0,
            gws_gameprovider_game_title: "",
            avail_games: [],
            avail_gameproviders: []
        });
        this.SID_GP = this.props.gameprovidersData.Subscribe("*", function (id, data) {
            _this.setState({ avail_gameproviders: data.data });
        });
        this.SID_GG = this.props.gamesData.Subscribe("*", function (id, data) {
            _this.setState({ avail_games: data.data });
        });
        this.doReSetRules();
    };
    PlayerFavoriteGamesEditor.prototype.componentWillUnmount = function () {
        this.props.gameprovidersData.UnSubscribe(this.SID_GP);
        this.props.gamesData.UnSubscribe(this.SID_GG);
    };
    PlayerFavoriteGamesEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            gws_gameprovider_rules: { isError: false },
            gws_gameprovider_game_rules: { isError: false }
        });
    };
    PlayerFavoriteGamesEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [бренд] не заполнено!" } });
            return false;
        }
        if ((this.state.gws_gameprovider_id <= 0) || (this.state.gws_gameprovider_title.length === 0)) {
            this.setState({ gws_gameprovider_rules: { isError: true, errorMessage: "Поле [геймпровайдер] не выбрано!" } });
            return false;
        }
        if ((this.state.gws_gameprovider_game_id <= 0) || (this.state.gws_gameprovider_game_title.length === 0)) {
            this.setState({ gws_gameprovider_game_rules: { isError: true, errorMessage: "Поле [игра] не выбрана!" } });
            return false;
        }
        return true;
    };
    PlayerFavoriteGamesEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_player_id: this.props.rootRecord.key,
                brand_id: this.state.brand_id,
                gws_gameprovider_id: this.state.gws_gameprovider_id,
                gws_gameprovider_game_id: this.state.gws_gameprovider_game_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Избранная игра добавлена!");
            });
        }
    };
    PlayerFavoriteGamesEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerFavoriteGamesEditor.prototype.getFormTitle = function () {
        return "Добавить избранную игру";
    };
    PlayerFavoriteGamesEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    }, function () {
                        _this.props.gameprovidersData.LoadDataByBrand(_this.state.brand_id);
                    });
                }, items: this.props.availBrands, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геймпровайдер:", placeholder: "Выберите геймпровайдер" }, value: { key: this.state.gws_gameprovider_id, value: this.state.gws_gameprovider_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_id: newVal.key,
                        gws_gameprovider_title: newVal.value,
                        gws_gameprovider_rules: { isError: false }
                    }, function () {
                        _this.props.gamesData.LoadData(_this.state.gws_gameprovider_id);
                    });
                }, items: this.state.avail_gameproviders, required: true, rules: this.state.gws_gameprovider_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игра:", placeholder: "Выберите игру" }, value: { key: this.state.gws_gameprovider_game_id, value: this.state.gws_gameprovider_game_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_game_id: newVal.key,
                        gws_gameprovider_game_title: newVal.value,
                        gws_gameprovider_game_rules: { isError: false }
                    });
                }, items: this.state.avail_games, required: true, rules: this.state.gws_gameprovider_game_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnEdit: "", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: function () { } })));
    };
    return PlayerFavoriteGamesEditor;
}(React.Component));
exports.default = PlayerFavoriteGamesEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/favorite_games/PlayerFavoriteGamesEditor.tsx
// module id = 1928
// module chunks = 0